module.exports = __webpack_public_path__ + "img/Nav_carrot.67a03cb9.svg";